import React, { useState, useEffect } from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import Pagination from "../../../../../../components/Pagination/Pagination";
import Calender from "../../../../../../assets/svg/icons/common/Calender";
import CaretDown from "../../../../../../assets/svg/icons/common/CaretDown";
import useCommonStore from "../../../../../../stores/common";
import useMerchantStore from "../../../../../../stores/merchant";
import DepositTable from "./table";
import { getMerchantDepositData } from "../../../../../../../api";
import moment from "moment";
import DateRangePicker from "../../../../../../components/form/date-range-picker";
import Spinner from "../../../../../../components/Loaders/Spinner";

function Deposit() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);

  const [depositData, setDepositData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const dateRange = useCommonStore((state) => state.dateRange);

  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    setLoading(true);
    getMerchantDepositData({
      mid: activeApp?.power_app_submission?.mid,
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
      page: currentPage,
    })
      .then((res) => {
        if (res.status) {
          setDepositData(res.data.data);
          setPageCount(res.data.last_page);
          setTotalItems(res.data.total);
          setItemsPerPage(res.data.per_page);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dateRange, currentPage]);

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Deposit/ACH details</h5>
              <ButtonIcon textColor="#254FE2">Expand All</ButtonIcon>
            </div>
            <div className={style.right}>
              {/* <DateRangePicker
                align="right"
                variant={!expandDetails ? "icon" : "largeFilter"}
                value={dateRange}
                onChange={(range) => {
                  setDateRange(range);
                }}
                placeholder={!expandDetails ? "" : "Select date range"}
                className={!expandDetails ? style.minimized_button : ""}
              />
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Filter />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon> */}
            </div>
          </header>

          <div className={style.body}>
            <DepositTable data={depositData} loading={loading} />
          </div>
          {!loading && (
            <footer className={style.footer}>
              <Pagination
                pageCount={pageCount}
                currentPage={currentPage - 1}
                onPageChange={({ selected }) => {
                  if (selected + 1 !== currentPage) {
                    setCurrentPage(selected + 1);
                  }
                }}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
              />
            </footer>
          )}
        </div>
      )}
    </>
  );
}

export default Deposit;
